import { Roles } from 'src/common/types'
import {
  AgreementAndPolicyTypes,
  AgreementAndPolicyCategories,
} from 'src/config/constants'

export const ageRangeOptions = ['Age', 'Grade']
export const licenseOptions = ['Daycare', 'Preschool', 'OOSC']
export const spaceTypes = ['Play Space', '', '']
export const prohibitedFoodOptions = [
  'Chicken',
  'Turkey',
  'Fish',
  'Pork',
  'Beef',
]
export const immunizationRecordOptions = [
  'DTaP-HB-IPV-Hib',
  'Men-C-C',
  'Pneu-C-13',
  'Rota',
  'MMRV',
]
export const exemptionReasonOptions = [
  'Medical Exemption',
  'Religious/Conscience Exemption',
  'Natural Immunity',
]
export const relationshipOptions = [
  'Parent',
  'Mom',
  'Dad',
  "Guardian's Partner",
  'Step Parent',
  'Foster Parent',
  'Aunt',
  'Uncle',
  'Grandma',
  'Grandpa',
  'Other',
]
export const occupationOptions = [
  'Unspecified',
  'Accounting',
  'Admin',
  'Banking',
  'Construction',
  'Engineering',
  'Food Service',
  'Human Resource',
  'IT',
  'Insurance',
  'Legal',
  'Manufacturing/Supply Chain',
  'Marketing/Advertising',
  'Medical/Healthcare',
  'Other',
]
export const memberTypeOptions = [
  'Legal Guardian',
  'Non-Guardian Emergency Contact',
  'Other',
]
export const pickupAuthOptions = ['Full', 'Limited', 'None']
export const currencyOptions = ['CAD']
export const regStatusOptions = ['Pending', 'Waitlisted']

export const regChainStatusOptions = ['Past', 'Pending', 'Current', 'Future']
export const templateTypeOptions = [
  { value: 'family', label: 'Family Members' },
  { value: 'student', label: 'Student' },
  { value: 'staff', label: 'Staff' },
]
export const gradeOptions = [
  'Preschool',
  'Kindergarten',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7+',
]
export const genericPod = [
  { id: 'generic', name: 'Generic', isArchived: false, isBussing: false },
]
export const langOptions = [
  { value: 'en-US', label: 'English' },
  // { value: 'fr-CA', label: 'Français' },
  // { value: 'zh-CN', label: '简体中文' }
]
export const timezoneOptions = [
  // { value: 'ADT', label: 'Atlantic Daylight Time' },
  { value: 'AST', label: 'Atlantic Standard Time' },
  // { value: 'AKDT', label: 'Alaska Daylight Time' },
  { value: 'AKDT', label: 'Alaska Standard Time' },
  // { value: 'CDT', label: 'Central Daylight Time' },
  { value: 'CST', label: 'Central Standard Time' },
  { value: 'EST', label: 'Eastern Standard Time' },
  // { value: 'EDT', label: 'Eastern Daylight Time' },
  { value: 'HST', label: 'Hawaiian Standard Time' },
  // { value: 'HDT', label: 'Hawaii Aleutian Daylight Time' },
  // { value: 'MDT', label: 'Mountain Daylight Time' },
  { value: 'MST', label: 'Mountain Standard Time' },
  { value: 'EDT', label: 'Newfoundland Standard Time' },
  // { value: 'NDT', label: 'Newfoundland Daylight Time' },
  // { value: 'PDT', label: 'Pacific Daylight Time' },
  { value: 'PST', label: 'Pacific Standard Time' },
]

export const staffGenderOptions = ['Male', 'Female', 'Other']
export const genderOptions = ['Male', 'Female', 'Unspecified']
export const spaceTypeOptions = [
  'Play Space',
  'Staff',
  'Walking',
  'Bus',
  'Other',
]
export const locationTypeOptions = ['School', 'Other']
export const taskTypeOptions = ['Per Hour', 'Per Month']
export const ageDictOptions = [
  { label: 'Age Range', value: 'number' },
  { label: 'Grade Range', value: 'grade' },
]
export const textTeamRatioOptions = ['Minority', 'Majority']
export const transportOptions = ['Walking', 'Bus', 'Other']

export const countryOptions = [
  { value: 'CA', label: 'Canada' },
  { value: 'USA', label: 'USA' },
]
export const stateOptions = {
  CA: [
    { value: 'AB', label: 'Alberta' },
    { value: 'BC', label: 'British Columbia' },
    { value: 'MB', label: 'Manitoba' },
    { value: 'NB', label: 'New Brunswick' },
    { value: 'NL', label: 'Newfoundland and Labrador' },
    { value: 'NT', label: 'Northwest Territories' },
    { value: 'NS', label: 'Nova Scotia' },
    { value: 'NU', label: 'Nunavut' },
    { value: 'ON', label: 'Ontario' },
    { value: 'PE', label: 'Prince Edward Island' },
    { value: 'QC', label: 'Quebec' },
    { value: 'SK', label: 'Saskatchewan' },
    { value: 'YT', label: 'Yukon' },
  ],
  USA: [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'DC', label: 'District Of Columbia' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
  ],
}

export const cityOptions = {
  AB: [
    { value: 'Airdrie', label: 'Airdrie' },
    { value: 'Calgary', label: 'Calgary' },
    { value: 'Edmonton', label: 'Edmonton' },
    { value: 'Grande Prairie', label: 'Grande Prairie' },
    { value: 'Lethbridge', label: 'Lethbridge' },
    { value: 'Medicine Hat', label: 'Medicine Hat' },
    { value: 'Strathcona County', label: 'Strathcona County' },
    { value: 'St. Albert', label: 'St. Albert' },
    { value: 'Wood Buffalo', label: 'Wood Buffalo' },
  ],
  BC: [
    { value: 'Vancouver', label: 'Vancouver' },
    { value: 'Surrey', label: 'Surrey' },
    { value: 'Burnaby', label: 'Burnaby' },
    { value: 'Richmond', label: 'Richmond' },
    { value: 'Abbotsford', label: 'Abbotsford' },
    { value: 'Coquitlam', label: 'Coquitlam' },
    { value: 'Kelowna', label: 'Kelowna' },
    { value: 'Langley', label: 'Langley' },
    { value: 'Saanich', label: 'Saanich' },
  ],
  MB: [{ value: 'MOCK', label: 'MOCK' }],
  NB: [{ value: 'MOCK', label: 'MOCK' }],
  NL: [{ value: 'MOCK', label: 'MOCK' }],
  NT: [{ value: 'MOCK', label: 'MOCK' }],
  NS: [{ value: 'MOCK', label: 'MOCK' }],
  NU: [{ value: 'MOCK', label: 'MOCK' }],
  ON: [{ value: 'MOCK', label: 'MOCK' }],
  PE: [{ value: 'MOCK', label: 'MOCK' }],
  QC: [{ value: 'MOCK', label: 'MOCK' }],
  SK: [{ value: 'MOCK', label: 'MOCK' }],
  YT: [{ value: 'MOCK', label: 'MOCK' }],
}

export const roleOptions = [
  { value: Roles.SuperAdmin, label: 'Super Admin' },
  { value: Roles.OrgAdmin, label: 'Org Admin' },
  { value: Roles.CenterAdmin, label: 'Center Admin' },
  { value: Roles.OfficeStaff, label: 'Office Staff' },
  { value: Roles.RoomStaff, label: 'Room Staff' },
]

export const studentStatusOptions = [
  'Pending',
  'Current',
  'Future',
  'Inactive',
  'Past',
]
export const studentStatusOptionsWithWaitlist = [
  'Pending (Not Waitlisted)',
  'Pending (Waitlisted)',
  'Current',
  'Future',
  'Inactive',
  'Past',
]
export const studentTagOptions = [
  'Onboarding',
  'Waitlist',
  'To Withdraw',
  'To End',
  'Ended',
]
export const studentSubStatusTags = [
  'Waitlist',
  'To Withdraw',
  'Withdrawn',
  'To End',
  'Ended',
  'Denied Enrollment',
  'Removed From Waitlist',
  'Tour',
  'Inquiry',
]
export const studentInfoTags = [
  'Allergies and Medical Conditions',
  'Drop In',
  'Special Needs',
  'Prohibited Meal',
  'Immunization Records',
  'Medication',
  'Flagged Member',
  'Unassigned Invoices',
]
export const studentImmunizationInfoTag = 'Immunization Records'
export function getStudentInfoTags(enableVaccinationTracking = true) {
  return enableVaccinationTracking
    ? studentInfoTags
    : studentInfoTags.filter((tag) => tag !== studentImmunizationInfoTag)
}
export const studentOnboardingTags = [
  'Basic Info',
  'Licensing Info',
  'Legal Guardian',
  'Non-Guardian Emergency Contact',
  'Auto Payments',
  'Bank Info',
  'Agreements',
]

export const clientPaymentMethodOptions = ['Credit Card', 'EFT']
export const paymentMethodOptions = [
  'Cash',
  'Credit Card',
  'Check',
  'Email Transfer',
  'Debit',
  'Direct',
]
export const refundOptions = [
  'Credit',
  'Cash',
  'Check',
  'Email Transfer',
  'Direct',
]
export const paymentStatusOptions = [
  'Processed',
  'Deposited',
  'Settled',
  'Rejected',
]
export const studentStaffOptions = ['Student', 'Staff', 'Member']
export const expiryTypes = [
  'Auto Adjustment',
  'Criminal Record',
  'First Aid',
  'Formal Review',
  'Immunization',
  'Intervention Check',
  'Medication',
  'Sponsor',
]

export const symptomOptions = [
  'Coughing/ Cold. Your child should be picked up immediately and must stay home until all symptoms have subsided (minimum of 24 hours).',
  'Fever. A warning that all is not right with the body. If your child has a fever of 38 C/ 100.4 F or higher than your child must stay home for 24 hours from the time their fever ends without the aid of medication.',
  'Vomiting. Your child must be picked up immediately. They must stay home for at least 24 hours from their last bout of vomiting.',
  'Diarrhea. In the event that your child has diarrhea two or more times in a day at the daycare, you must immediately pick them up. Your child should remain home for 24 hours from their last bout of diarrhea and until they have had a normal bowl movement.',
  'Sinus Infection. Greenish discharge from nose might be a sign of an infection. Child needs to stay home until symptoms are gone.',
  'Head Lice. Your child must be picked up immediately and treated with medicated shampoo. The child must stay home for at least 24 hours from the first medicated shampoo use and until it is confirmed by parents and staff that the head lice has been eliminated.',
  'Pink Eye (Conjunctivitis). Identified when the eye has discharge, is glassy or pink in the whites. Your child is to be picked up immediately and treated with prescription medication for a full 24 hours before they are permitted to return the daycare. If there is still a discharge, the child must remain home until the discharge is gone.',
  'Ear Infection. If your child complains of their ear hurting or for nonverbal child, they are fussy and grab at their ear, then an Ear Infection is suspect. You must pick up your child immediately. They may return when they are at a normal temperature and show no signs of pain.',
  'Sore Throat. If your child complains of a sore throat, you must pick up your child immediately. They may return when they are at a normal temperature and show no signs of pain.',
  'Other (see comments below)',
]

export const ROLLOVER_OPTION_NONE = {
  id: 'None',
  name: 'None',
}

export const GENERIC_OPTION = {
  id: 'Generic',
  name: 'Generic',
}

export const AUTOMATIC_GROUP_OPTION = {
  id: 'Automatic',
  name: 'Automatic',
  ageGroups: [],
  capacity: 0,
}

export const months: string[] = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]
export const DAYS_MONTH_MAP: { [index: number]: number } = {
  0: 31,
  1: 28,
  2: 31,
  3: 30,
  4: 31,
  5: 30,
  6: 31,
  7: 31,
  8: 30,
  9: 31,
  10: 30,
  11: 31,
}

export const AgreementAndPolicyTypeOptions = Object.values(
  AgreementAndPolicyTypes,
)
export const AgreementAndPolicyCategoryOptions = Object.values(
  AgreementAndPolicyCategories,
)

export const REG_SLOT_FILTER_OTPIONS = [
  'Full Time',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export const ACTIVE_CAMPAIGN_CONTACT_STATUSES = [
  {
    value: -1,
    label: 'Any',
  },
  {
    value: 0,
    label: 'Unconfirmed',
  },
  {
    value: 1,
    label: 'Active',
  },
  {
    value: 2,
    label: 'Unsubscribed',
  },
  {
    value: 3,
    label: 'Bounced',
  },
]

export const STUDENT_CARE_TYPES = [
  {
    value: 'Regular Extended Care',
    label: 'Regular/Extended Care',
  },
  {
    value: 'Overnight Care',
    label: 'Overnight Care',
  },
]

export const ageCheckStrategyOptions = [
  {
    value: 'startOfMonth',
    description: 'quickHelp.rateSetup.ageCheckStartOfMonth',
    chipClass: 'tw-bg-primary tw-text-white',
  },
  {
    value: 'endOfMonth',
    description: 'quickHelp.rateSetup.ageCheckEndOfMonth',
    chipClass: 'tw-bg-primary tw-text-white',
  },
  {
    value: 'custom',
    description: 'quickHelp.rateSetup.ageCheckCustom',
    chipClass: 'tw-bg-primary tw-text-white',
  },
]

export const frequencyOptions = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'annual', label: 'Annual' },
  { value: 'oneTime', label: 'One Time' },
  { value: 'other', label: 'Other' },
]
